import React, { useCallback } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./style.less";
import moment from "moment";

const shortenWeekDayName = (locale, date) => moment(date).format("dd")[0];

function ModifiedCalendar({
  onChange,
  selectRange,
  maxDate,
  dateRange,
  date,
  tileClassName,
  view,
  onActiveStartDateChange
}) {
  const callOnChange = useCallback(
    value => {
      if (selectRange) {
        const mapped = value.map(e => moment(e));
        if (onChange) {
          onChange(mapped);
        }
      } else {
        if (onChange) {
          onChange(moment(value));
        }
      }
    },
    [onChange, selectRange]
  );

  return (
    <div className="ModifiedCalendar">
      <Calendar
        onChange={callOnChange}
        formatShortWeekday={shortenWeekDayName}
        showNeighboringMonth={false}
        selectRange={selectRange}
        maxDate={maxDate && maxDate.toDate()}
        tileClassName={
          tileClassName
            ? ({ date, view }) => tileClassName({ date: moment(date), view })
            : null
        }
        onActiveStartDateChange={
          onActiveStartDateChange
            ? ({ activeStartDate }) =>
                onActiveStartDateChange({
                  activeStartDate: moment(activeStartDate)
                })
            : null
        }
        value={selectRange ? dateRange.map(e => e.toDate()) : date.toDate()}
      />
    </div>
  );
}

export default ModifiedCalendar;
